<script setup lang="ts">
  import { Modal } from 'bootstrap'
  import { ref, onMounted } from 'vue'
  import useSawNewsStore from '../store/pinia/useSawNews.store'

  const modal = ref<InstanceType<typeof Modal> | null>(null)
  const player = ref<HTMLIFrameElement | null>(null)
  const sawNewsStore = useSawNewsStore()

  function stopVideo() {
    player.value?.contentWindow?.postMessage(
      '{"event":"command","func":"stopVideo","args":""}',
      '*',
    )
  }

  function playVideo() {
    player.value?.contentWindow?.postMessage(
      '{"event":"command","func":"playVideo","args":""}',
      '*',
    )
  }

  onMounted(() => {
    modal.value = new Modal('#modal-onboarding-video', {
      backdrop: 'static',
      keyboard: false,
    })

    player.value = document.getElementById('player') as HTMLIFrameElement
    stopVideo()
  })

  function show() {
    modal.value?.show()
    playVideo()
  }

  function hide() {
    stopVideo()
    sawNewsStore.setSawNews()
    modal.value?.hide()
  }

  defineExpose({ show, hide })
</script>

<template>
  <div
    id="modal-onboarding-video"
    class="modal modal-md fade"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content mb-3">
        <div class="modal-header pb-0 pt-4 ps-3 pe-4">
          <h5 class="modal-title plugin-modal-title">Temos novidade!</h5>
          <button class="btn-close" @click="hide" />
        </div>

        <div class="modal-body px-1">
          <p class="fs-6 text-start px-3">
            A partir de agora,
            <strong>
              você pode escolher cadastrar uma senha para usar seu Certificado
              Digital .</strong
            >
            Veja como funciona no vídeo abaixo:
          </p>

          <iframe
            id="player"
            src="https://www.youtube.com/embed/QuoiuQeDFFc?mute=1&rel=0&showinfo=0&enablejsapi=1"
            title="YouTube video player"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .modal-content {
    border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
    border-radius: var(--bs-modal-border-radius);
  }

  #player {
    width: 90%;
    height: 65%;
  }

  @media (min-width: 576px) {
    .modal-md {
      --bs-modal-width: 630px;
    }

    #player {
      width: 600px;
      height: 338px;
    }
  }
</style>
